<template>
	<div class="catalog-dialog">
		<div class="catalog-dialog-card" :style="`background-color: ${theme.base};`">
			<div class="catalog-dialog-card-header">
				<div class="catalog-dialog-card-header-text">
					<h2>{{ title }}</h2>
					<p>{{ description }}</p>
				</div>
				<div class="catalog-dialog-card-header-btn">
					<button
						:style="`background-color: ${theme.base};`"
						type="button"
						@click="$emit('close-gallery')"
					>
						<v-icon color="primary">close</v-icon>
					</button>
				</div>
			</div>
			<div class="catalog-dialog-card-body">
				<img
					:src="imageSelected"
					:alt="title"
					class="catalog-dialog-card-body-img"
				/>
			</div>
			<div class="catalog-dialog-card-footer">
				<div class="catalog-dialog-card-footer-preview">
					<button
						v-for="(item, index) in images"
						:key="index"
						class="catalog-dialog-card-footer-preview-item"
						:class="{ 'opacity' : item.urlImage !== imageSelected }"
						type="button"
						@click="showImage(item)"
					>
						<img
							:src="item.urlImage"
							alt="imagen"
						/>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	function created() {
		this.showImage(this.images[0]);
	}

	function showImage({ urlImage }) {
		this.imageSelected = urlImage;
	}

	function data() {
		return {
			imageSelected: '',
		};
	}

	export default {
		name: 'catalog-dialog',
		created,
		data,
		methods: {
			showImage,
		},
		props: {
			description: String,
			images: {
				default: () => [],
				type: Array,
			},
			theme: {
				default: () => {},
				type: Object,
			},
			title: String,
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-dialog {
		align-items: center;
		background-color: rgba(169, 169, 169, .2);
		bottom: 0;
		display: flex;
		height: 100vh;
		justify-content: center;
		left: 0;
		position: fixed;
		right: 0;
		top: 0;
		width: 100vw;
		z-index: 4;

		&-card {
			border-radius: 8px;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
			color: #494949;
			height: 415px;
			padding: 15px 23px 20px;
			width: 90%;

			@media (min-width: 936px) {
				height: 657px;
				padding: 26px 40px 21px;
				width: 580px;
			}

			&-header {
				display: flex;

				&-text {
					max-width: 90%;
				}

				&-btn {
					margin-left: auto;

					button {
						border-radius: 100%;
						box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
						height: 30px;
						width: 30px;

						@media (min-width: 936px) {
							height: 40px;
							width: 40px;
						}
					}

					.icon {
						font-size: 16px !important;

						@media (min-width: 936px) {
							font-size: 24px !important;
						}
					}
				}
			}

			h2 {
				font-size: 21px;
				font-weight: normal;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			p {
				font-size: 12px;
				font-weight: bold;
				margin: 0px;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				text-transform: uppercase;
				white-space: nowrap;
			}

			&-body {
				align-items: center;
				display: flex;
				height: 256px;
				justify-content: center;
				margin: 21px auto 17px;

				@media (min-width: 936px) {
					height: 455px;
					margin: 27px auto 23px;
				}

				img {
					border-radius: 8px;
					max-height: 100%;
					max-width: 100%;
				}
			}

			&-footer {
				overflow-y: scroll;
				height: 46px;

				@media (min-width: 936px) {
					height: 60px;
				}

				&-preview {
					display: inline-flex;
					flex: 1;
					flex-direction: column;
					flex-wrap: wrap;
					height: 100%;

					&-item {
						border: 1px solid #c9c6c6;
						border-radius: 8px;
						height: 46px;
						margin-right: 5px;
						overflow: hidden;
						width: 51px;

						@media (min-width: 936px) {
							height: 60px;
							margin-right: 9px;
							width: 65px;
						}

						&.opacity {
							opacity: .52;
						}
					}
				}

				img {
					border-radius: 8px;
					height: 100%;
					width: 100%;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-dialog.vue